// extracted by mini-css-extract-plugin
module.exports = {"privacy":"Privacy_privacy__t2P1m","privacy__list-heading":"Privacy_privacy__list-heading__1MfSC"};